"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EpsilonSectionEditorPreviewer = /** @class */ (function () {
    /**
     * Class constructor
     */
    function EpsilonSectionEditorPreviewer() {
        jQuery(document).on('click', '.epsilon-section-editor', function (e) {
            e.preventDefault();
            var object = {
                section: jQuery(this).parents('[data-section]').attr('data-section'),
                customizerSection: jQuery(this).parents('[data-section]').attr('data-customizer-section-id')
            };
            wp.customize.preview.send('epsilon-section-edit', object);
        });
    }
    return EpsilonSectionEditorPreviewer;
}());
exports.EpsilonSectionEditorPreviewer = EpsilonSectionEditorPreviewer;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/previewer/section-editor/section-editor.ts
// module id = 31
// module chunks = 1